// @generated
// This file is automatically generated by Kanel. Do not modify manually.

import { z } from 'zod';

/** Represents the enum public.organization_status */
enum OrganizationStatus {
  NEW = 'NEW',
  ONBOARDING = 'ONBOARDING',
  GESTATING = 'GESTATING',
  LIVE = 'LIVE',
  DEAD = 'DEAD',
  TEST = 'TEST',
};

export default OrganizationStatus;

/** Zod schema for organization_status */
export const organizationStatus = z.enum([
  'NEW',
  'ONBOARDING',
  'GESTATING',
  'LIVE',
  'DEAD',
  'TEST',
]);
